import {
  getToken,
  setToken,
  removeUSERINFO,
  removeToken,
  removeSYSTEMINFO,
  getUSERINFO,
  getSYSTEMINFO,
  setUSERINFO,
  setSYSTEMINFO
} from '@/store/cookies'
import store from '@/store'
import route from '@/router'
import { Message } from 'view-design'
import {
  getExternalTicket,
  clearExternalTicket,
  isTicketUsed,
  markTicketUsed,
  describeTicketError,
  describeTicketFailure,
  ticketFingerprint,
  stripTicketQuery
} from '@/utils/sso'
const whiteRouter = ['/login']

// 兜底路由：必须在动态路由之后 addRoutes，写进初始routes会让通配符先于菜单页匹配、把全站吃成404
const notFoundRouter = [{ path: '*', redirect: '/404', hidden: true }]

// 在途的外链换票任务：拦截器碰到401会push('/login')重跑本钩子，防止同一张票被并发消费两次
let externalTask = null

/**
 * 外链换票：快照旧会话 → 清登录态 → 换票 → 建动态路由
 * @returns {Promise<string>} 落地路径；失败时reject的err带restoreSession标记
 */
function runExternalLogin(external) {
  // 快照旧登录态：换票失败时要还原，不能打死正在用的会话
  const snapshot = { token: getToken(), userinfo: getUSERINFO(), systeminfo: getSYSTEMINFO() }
  // 先清本系统旧令牌，避免换票请求带着过期Bearer被判401
  removeUSERINFO()
  removeSYSTEMINFO()
  removeToken()
  return store.dispatch(external.action, external.payload).then((target) => {
    markTicketUsed(external.name, external.ticket)
    clearExternalTicket()
    return store.dispatch('menu/dynamicAddRouter', store.getters['menu/getArrJurisdiction']).then(() => target)
  }).then((target) => {
    route.addRoutes(store.getters['menu/getASYNCROUTERS'].concat(notFoundRouter))
    route.options.routes = store.getters['menu/getALLROUTERS']
    externalTask = null
    // ask登录直落大屏首个菜单，不进密码登录那套 /index 控制台
    return target || '/BigScreen'
  }).catch((rawErr) => {
    externalTask = null
    console.log('外链登录失败', describeTicketFailure(rawErr))
    // 必须标记并抹掉票据，否则和本钩子形成死循环
    markTicketUsed(external.name, external.ticket)
    clearExternalTicket()
    const restore = Boolean(snapshot.token)
    if (restore) {
      setToken(snapshot.token)
      if (snapshot.userinfo) setUSERINFO(snapshot.userinfo)
      if (snapshot.systeminfo) setSYSTEMINFO(snapshot.systeminfo)
    }
    Message.error({ content: restore ? '外链登录失败，已保持在原登录状态' : describeTicketError(rawErr), duration: 5 })
    const err = rawErr instanceof Error ? rawErr : new Error(describeTicketError(rawErr))
    err.restoreSession = restore
    return Promise.reject(err)
  })
}

route.beforeEach((to, from, next) => {
  let external = null
  try {
    external = getExternalTicket()
  } catch (error) {
    // 守卫是同步执行的，异常抛出去就没人调next()
    console.error('外链票据解析异常，按无票据处理', error)
  }
  if (external && !isTicketUsed(external.name, external.ticket)) {
    const key = ticketFingerprint(external.name, external.ticket)
    if (!externalTask || externalTask.key !== key) {
      externalTask = { key: key, task: runExternalLogin(external) }
    }
    // 换票只跑一次，但每次导航各自挂自己的next回调
    const task = externalTask.task
    task.then((path) => {
      next({ path, replace: true })
    }).catch((err) => {
      if (err && err.restoreSession) {
        // 老会话已还原，重跑本钩子；query要剥掉票据，否则ask会被写回地址栏
        next({ path: to.path, query: stripTicketQuery(to.query), hash: to.hash, replace: true })
      } else {
        next('/login')
      }
    })
    return
  }
  const token = getToken()
  if (token) {
    if (to.path === '/login') {
      removeUSERINFO()
      removeSYSTEMINFO()
      removeToken()
      store.commit('menu/removeSYSTEMINFO')
      store.commit('menu/removeToken')
      store.commit('menu/removeUSERINFO')
      store.commit('menu/removeASYNCROUTERS')
      store.commit('menu/removeALLROUTERS')
      store.commit('menu/removeArrJurisdiction')
      store.commit('menu/removeBUTTONS')
      next()
    } else if (to.path === null) {
      next('*')
    } else {
      if (store.getters['menu/getASYNCROUTERS'].length === 0) {
        store.dispatch('menu/dynamicAddRouter', store.getters['menu/getArrJurisdiction']).then(res => {
          route.options.routes = store.getters['menu/getALLROUTERS']
          route.addRoutes(store.getters['menu/getASYNCROUTERS'].concat(notFoundRouter))
          // to.matched是addRoutes前算的、不会回填，裸next()会沿用那份空匹配渲染出白屏，所以路径或matched数不一致就用重匹配结果重发一次导航
          const target = route.match(to.fullPath)
          if (target.path !== to.path || (to.matched.length === 0 && target.matched.length > 0)) {
            next({ path: target.path, query: target.query, hash: target.hash, params: to.params, replace: true })
          } else {
            next()
          }
        }).catch(err => {
          console.error('动态路由加载失败:', err)
          next('/login')
        })
      } else {
        // 按name跳转但name没注册时，vue-router会把path兜成'/'、matched清空，静态'/'那条的redirect根本轮不到执行
        if (to.matched.length === 0) {
          next('/404')
        } else {
          next()
        }
      }
    }
  } else {
    if (whiteRouter.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})

